import CONSTANTS from './constants';

const links = [
  {
    routes: ["/dashboard"],
    icon: "BsSpeedometer2",
    name: "Inicio",
    permissions: ["readCompany", "writeCompany"],
    superadminOnly: true,
    allowedCompanyIds: ["675dbda724aa9a000835cd92", "5ed824990274390007afcc70", "678728e824aa9a0009c9707e", "68645f238e6d01000893892d"],
  },
  {
    routes: ["/chat"],
    icon: "BsChatLeftFill",
    name: "Chat",
    permissions: ["readChat", "agent"],
  },
  {
    routes: ["/boards", "/board"],
    icon: "BsKanban",
    name: "Boards",
    permissions: ["readChat", "agent"],
  },
  {
    routes: ["/contacts"],
    icon: "BsPeople",
    name: "Contactos",
    permissions: ["agent"],
  },
  {
    routes: [
      CONSTANTS.MULTIMEDIA_ROUTE,
      CONSTANTS.ALBUM_ROUTE,
      CONSTANTS.SUBALBUM_ROUTE,
    ],
    icon: "BsImages",
    name: "Multimedia",
    permissions: ["readMultimedia", "writeMultimedia"],
  },
  {
    routes: [
      CONSTANTS.QUICK_ANSWERS_ROUTE,
      CONSTANTS.QUICK_ANSWERS_ACTION_ROUTE,
    ],
    icon: "BsLightning",
    name: "Respuestas",
    permissions: ["readQuickAnswers", "writeQuickAnswers"],
  },
  {
    routes: ["/users", "/users/new"],
    icon: "BsPersonGear",
    name: "Equipo",
    permissions: ["readUsers", "writeUsers"],
  },
  {
    routes: ["/bot"],
    icon: "BsRobot",
    name: "Bot",
    permissions: ["readBot", "writeBot"],
  },
  {
    routes: ["/broadcast/table"],
    icon: "BsMegaphone",
    name: "Campañas",
    permissions: ["campaigns"],
  },
  {
    routes: ["/analytics"],
    icon: "BsTrophy",
    name: "Estadísticas",
    permissions: ["readAnalytics"],
  },
  {
    routes: ["/spaces", "spaces/new"],
    icon: "BsWhatsapp",
    name: "Canales",
    permissions: ["readSpaces", "writeSpaces"],
  },
  {
    routes: [
      "/config",
      "/config/new-tag",
      "/config/new-rol",
      "/config/new-datasheet",
      "/config/edit-plan",
      "/config/edit-card",
      "/config/album",
    ],
    icon: "BsGear",
    name: "Configuración",
    permissions: [
      "readCompany",
      "writeCompany",
      "readPayments",
      "writePayments",
      "readTags",
      "writeTags",
      "readRols",
      "writeRols",
      "readDataSheetConfiguration",
      "writeDataSheetConfiguration",
    ],
  },
  {
    routes: ["/account", CONSTANTS.UPDATE_SUBSCRIPTION_ROUTE],
    icon: "BsPersonBadge",
    name: "Cuenta",
    permissions: [
      "readCompany",
      "writeCompany",
      "readPayments",
      "writePayments"
    ],
  },
  {
    routes: ["/help"],
    icon: "BsQuestionCircle",
    name: "Ayuda",
    permissions: ["readCompany", "writeCompany"],
  },
];

export default links;
